export default ['small', 'large']
